// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f5b0a801","87":"6c106bca","695":"eabf8480"}[chunkId] + ".chunk.js";
};